import React, { Component } from "react";
import PropTypes from "prop-types";
import _, { get } from "lodash";
import classNames from "classnames";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  CANCELLABLE_COST_ADJUSTMENTS,
  COST_ADJUSTMENT_OPTIONS,
  SCRAP_REPORT
} from "MODULES/inventories/constants";
import { Authorized, Delete } from "MODULES/shared/components";
import { QUALITY_CONTROL, ACCOUNTING_MANAGER } from "MODULES/users/constants";
import { isLessThan24HoursAgo } from "LIB/time";
import { cancelCostAdjustment } from "../../../actions";

const displayCostAdjLabel = costAdj => {
  const label = _.get(
    COST_ADJUSTMENT_OPTIONS,
    `${costAdj.adjustment_type}.label`
  );
  if (typeof label === "function") {
    return label(costAdj.subtype);
  }
  return label;
};

export default class CostAdjustmentTable extends Component {
  static propTypes = {
    costAdjustments: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
    inventory: PropTypes.shape({})
  };

  canDelete = costAdj =>
    (costAdj.adjustment_type === "neg_depreciation" &&
      !get(this.props.inventory, SCRAP_REPORT)) ||
    (isLessThan24HoursAgo(costAdj.created_at) &&
      CANCELLABLE_COST_ADJUSTMENTS.includes(costAdj.adjustment_type));

  renderRow = (r, idx) => {
    const classes = classNames({ "text-muted": r.cancelled });
    return (
      <tr key={idx} className={classes}>
        <td>{shortDate(r.created_at)}</td>
        <td>{r.created_by && r.created_by.full_name}</td>
        <td>{displayCostAdjLabel(r)}</td>
        <td className="text-right">{dollars(r.adjustment)}</td>
        <Authorized roles={[QUALITY_CONTROL]} subroles={[ACCOUNTING_MANAGER]}>
          {this.canDelete(r) ? (
            <Delete
              deleteAction={cancelCostAdjustment}
              id={r.id}
              primary={r.cancelled}
            />
          ) : (
            <th />
          )}
        </Authorized>
      </tr>
    );
  };

  render() {
    return (
      <div>
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Date Created</th>
              <th>Adjusted By</th>
              <th>Adjustment Type</th>
              <th className="text-right">Cost Adjustment</th>
              <Authorized roles={[QUALITY_CONTROL]}>
                <th />
              </Authorized>
            </tr>
          </thead>
          <tbody>{this.props.costAdjustments.map(this.renderRow)}</tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/CostAdjustmentTable/CostAdjustmentTable.jsx